import colors from './colors';
import resolutions from './resolutions';
import createTheme from './createTheme';
import { DEFAULT_THEME_MODE, THEME_MODES } from './constants';

const defaultTheme = createTheme(DEFAULT_THEME_MODE);

export { colors, resolutions, createTheme, DEFAULT_THEME_MODE, THEME_MODES };

export default {
  ...defaultTheme,
  colors: {
    ...defaultTheme.colors,
  },
  // Height
  heightBase: '38px',
  heightHeader: '60px',
  heightHeaderMobile: '55px',
  heightFooter: '46px',
  // Width
  widthSidebar: '240px',
  // Marker
  markerIconSize: '16px',
  // Fonts
  fontFamilyRoboto: '"Roboto", sans-serif',
  fontFamilyInterui: '"Inter UI", sans-serif',
  fontFamilyLato: '"Lato", sans-serif',
  fontFamilyRubik: '"Rubik", sans-serif',
  fontFamilySystem:
    '-apple-system, BlinkMacSystemFont, "Inter UI", Roboto, sans-serif',
  fontWeightMedium: 500,
  fontWeightSemibold: 600,
  fontWeightBold: 700,
};
